import React, { useState } from "react";
import { FlexibleDiv } from "../Box/styles";
import { TakeLessonsWithYouWrap } from "./styles";
import { Typography } from "antd";
import PhoneInHand from "../../assets/pngs/phoneInHand.png";
import Windows from "../../assets/pngs/windows.png";
import Android from "../../assets/pngs/android.png";
import DesktopDownloadModal from "../DesktopDownloadModal";

const TakeLessonsWithYou = () => {
  const [showModal, setShowModal] = useState(false);
  const { Text, Title } = Typography;

  return (
    <TakeLessonsWithYouWrap>
      <FlexibleDiv className="takeLessonsWithYou" margin="0 0 40px 0">
        <FlexibleDiv
          className="takeLessonsWithYou__card"
          height="max-content"
          justifyContent="space-evenly"
          flexDir="column-reverse"
        >
          <FlexibleDiv
            width="60%"
            height="auto"
            className="takeLessonsWithYou__cardImage"
          >
            <img src={PhoneInHand} alt="" />
          </FlexibleDiv>
          <FlexibleDiv
            flexDir="column"
            width="80%"
            justifyContent="flex-start"
            className="takeLessonsWithYou__cardBody"
          >
            <Title>Take Your Lessons With You</Title>
            <Text className="subHeader">Download the Exampadi App</Text>
            <FlexibleDiv
              className="takeLessonsWithYou__linksWrap"
              justifyContent="space-between"
              flexDir="column"
              width="300px"
              height="max-content"
            >
              <FlexibleDiv flexDir="column" width="max-content">
                <Text className="takeLessonsWithYou__linksHeaderText">
                  On Mobile
                </Text>
                <a
                  href="https://play.google.com/store/apps/details?id=com.exampadi"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FlexibleDiv
                    className="takeLessonsWithYou__links"
                    width="120px"
                    justifyContent="space-evenly"
                    height="35px"
                  >
                    <img src={Android} alt="" /> <span>Android</span>
                  </FlexibleDiv>
                </a>
              </FlexibleDiv>
              <FlexibleDiv flexDir="column" width="max-content">
                <Text className="takeLessonsWithYou__linksHeaderText">
                  On Desktop
                </Text>
                <small
                  onClick={() => {
                    setShowModal(true);
                  }}
                >
                  <FlexibleDiv
                    className="takeLessonsWithYou__links one"
                    width="120px"
                    justifyContent="space-evenly"
                    height="35px"
                  >
                    <img src={Windows} alt="" /> <span>Windows</span>
                  </FlexibleDiv>
                </small>
              </FlexibleDiv>
            </FlexibleDiv>
          </FlexibleDiv>
        </FlexibleDiv>
      </FlexibleDiv>
      <DesktopDownloadModal showModal={showModal} setShowModal={setShowModal} />
    </TakeLessonsWithYouWrap>
  );
};

export default TakeLessonsWithYou;
